// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function mergeRefs<T = any>(
  refs: Array<
    React.MutableRefObject<T> | React.LegacyRef<T> | undefined | null
  >,
): React.RefCallback<T> {
  return (value) => {
    for (const ref of refs) {
      if (typeof ref === 'function') {
        ref(value)
        // eslint-disable-next-line unicorn/no-null
      } else if (ref != null) {
        ;(ref as React.MutableRefObject<T | null>).current = value
      }
    }
  }
}

export * from './use-device'
export * from './use-window-size'
export * from './use-current-date'
export * from './use-img-cached'

export type ClassNameProps = { className?: string }
export type ChildrenProps = React.PropsWithChildren
export type StyleProps = { style?: React.CSSProperties }
